import { render, staticRenderFns } from "./DashboardItemLink.vue?vue&type=template&id=bdcc65b0&scoped=true&"
import script from "./DashboardItemLink.ts?vue&type=script&lang=ts&"
export * from "./DashboardItemLink.ts?vue&type=script&lang=ts&"
import style0 from "./DashboardItemLink.scss?vue&type=style&index=0&id=bdcc65b0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcc65b0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VCard,VCardText,VIcon})
